export const WARRANTY_CLAIM_STORAGE_KEY = "WARRANTY_CLAIM";

export const getClaimRemainingQuantity = (item, warrantyFlow = false) =>
  Number(warrantyFlow
    ? item?.warranty_claim_remaining_qty ?? 0
    : item?.remaining_qty ?? item?.quantity ?? 0);

const WARRANTY_CLAIM_QUERY_KEYS = [
  "claim_warrenty",
  "warranty_claim",
];

const getWarrantyClaimStorage = (storage) => {
  if (storage) {
    return storage;
  }

  if (typeof window === "undefined") {
    return null;
  }

  return window.sessionStorage;
};

export const getWarrantyClaimUrlParam = (params) => {
  for (const key of WARRANTY_CLAIM_QUERY_KEYS) {
    const value = params?.get?.(key);

    if (value !== null && value !== undefined) {
      return value;
    }
  }

  return null;
};

export const rememberWarrantyClaimParam = (params, storage) => {
  const value = getWarrantyClaimUrlParam(params);

  if (value === null) {
    return;
  }

  try {
    const targetStorage = getWarrantyClaimStorage(storage);
    const normalizedValue = value.toLowerCase();

    if (normalizedValue === "true") {
      targetStorage?.setItem(WARRANTY_CLAIM_STORAGE_KEY, "true");
    } else if (normalizedValue === "false") {
      targetStorage?.removeItem(WARRANTY_CLAIM_STORAGE_KEY);
    }
  } catch {
    // Continue with the URL value when browser storage is unavailable.
  }
};

export const getWarrantyClaimParam = (params, storage) => {
  const urlValue = getWarrantyClaimUrlParam(params);

  if (urlValue !== null) {
    return urlValue;
  }

  try {
    return (
      getWarrantyClaimStorage(storage)?.getItem(
        WARRANTY_CLAIM_STORAGE_KEY,
      ) ?? null
    );
  } catch {
    return null;
  }
};

export const appendWarrantyClaimParam = (
  sourceParams,
  targetParams = new URLSearchParams(),
  storage,
) => {
  const value = getWarrantyClaimParam(sourceParams, storage);

  if (value?.toLowerCase() === "true") {
    targetParams.set("claim_warrenty", "true");
  }

  return targetParams;
};
